import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  AwsCallState,
  AwsPermissionType,
  CommunicationTransitions,
  EntitiesResponse,
} from '../types/awsCall.types'

const initialState: AwsCallState = {
  incomingCall: false,
  incomingPhoneNumber: null,
  associatedRecords: {},
  agentStatus: '',
  interactionTransitionState: {},
  callType: '',
  programId: '',
  interactionId: '',
  awsPermission: {
    control: false,
    id: 0,
    key: '',
    label: '',
    uiDataType: '',
    value: '',
  },
}

const awsCallSlice = createSlice({
  name: 'awsCall',
  initialState,
  reducers: {
    setIncomingCall: (state, action: PayloadAction<boolean>) => {
      state.incomingCall = action.payload
    },
    setIncomingPhoneNumber: (state, action: PayloadAction<string | null>) => {
      state.incomingPhoneNumber = action.payload
    },
    setAssociatedRecords: (state, action: PayloadAction<EntitiesResponse>) => {
      state.associatedRecords = action.payload
    },
    setAgentStatus: (state, action: PayloadAction<string>) => {
      state.agentStatus = action.payload
    },
    setInteractionTransitionState: (
      state,
      action: PayloadAction<CommunicationTransitions>
    ) => {
      state.interactionTransitionState = action.payload
    },
    setCallType: (state, action: PayloadAction<string>) => {
      state.callType = action.payload
    },
    setAwsPermission: (state, action: PayloadAction<AwsPermissionType>) => {
      state.awsPermission = action.payload
    },
    setProgramId: (state, action: PayloadAction<string>) => {
      state.programId = action.payload
    },
    setInteractionId: (state, action: PayloadAction<string>) => {
      state.interactionId = action.payload
    },
    resetAwsCall: () => initialState,
    setAllCallData: (state, action: PayloadAction<Partial<AwsCallState>>) => {
      Object.assign(state, action.payload)
    },
  },
})

export const {
  setIncomingCall,
  setIncomingPhoneNumber,
  resetAwsCall,
  setAssociatedRecords,
  setAgentStatus,
  setInteractionTransitionState,
  setCallType,
  setAwsPermission,
  setProgramId,
  setInteractionId,
  setAllCallData,
} = awsCallSlice.actions
export default awsCallSlice.reducer
